import script from "./DateSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DateSelector.vue?vue&type=script&setup=true&lang=js"

import "./DateSelector.vue?vue&type=style&index=0&id=17cfffd8&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cfffd8"]])

export default __exports__